import React from "react";

const LoadingBox = ({ isOpen }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-[#fafaf8]/90 backdrop-blur-sm flex items-center justify-center z-50 px-6">
      <div className="bg-white border border-[#e8e8e4] rounded-none shadow-none p-12 max-w-md w-full text-center">
        <p className="text-sm tracking-[0.2em] uppercase text-[#E78730] mb-6">
          Please Wait
        </p>

        <h3 className="font-serif text-2xl text-[#1a1a1a] leading-snug mb-10">
          Processing Your Request
        </h3>

        <div className="flex justify-center">
          <div className="w-12 h-12 border border-[#e8e8e4] border-t-[#E78730] rounded-full animate-spin"></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingBox;
